<!--ui-wrapper style="display: none;"-->
<div class="container-fluid h-100 w-100 m-0 p-0 position-relative" id="ui" style="z-index:1; pointer-events: none">
  <div class="position-absolute h-100 right-0 d-flex align-items-center" style="z-index:1">
    <app-floating-menu (hideMenu)="hideMenu($event)"></app-floating-menu>
  </div>
  <div class="position-absolut h-100 w-100 m-0 p-0 d-flex flex-column justify-content-end" style="z-index:1"
    [class.invisible]="hiddenMenu">
    <app-menu></app-menu>
  </div>
</div>